import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ClerkProvider } from "@clerk/react";

const appearance = {
  variables: {}
};

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const DEFAULT_KEY = "pk_test_cmVuZXdpbmctZ2FyZmlzaC0zNTQzLmNsZXJrLmFjY291bnRzLmRldiQ";

export default function ClerkAuthProvider({ children }) {
  const navigate = useNavigate();
  const [config, setConfig] = useState({
    enabled: true,
    publishable_key: DEFAULT_KEY,
    proxy_url: ""
  });
  const [unavailable, setUnavailable] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        const url = BACKEND_URL ? `${BACKEND_URL}/api/clerk/config` : "/api/clerk/config";
        const res = await fetch(url);
        const cfg = await res.json();
        if (cfg?.publishable_key) return cancelled || setConfig(cfg);
      } catch {}
    };
    load();
    return () => { cancelled = true; };
  }, []);

  if (unavailable) return <p style={{ padding: 24 }}>Sign-in is unavailable right now. Refresh the page to try again.</p>;
  if (!config) return null;
  return (
    <ClerkProvider
      publishableKey={config.publishable_key}
      proxyUrl={config.proxy_url || undefined}
      appearance={appearance}
      routerPush={(to) => navigate(to)}
      routerReplace={(to) => navigate(to, { replace: true })}
      signInUrl="/sign-in"
      signUpUrl="/sign-up"
      signInFallbackRedirectUrl="/"
      signUpFallbackRedirectUrl="/"
      afterSignOutUrl="/"
    >
      {children}
    </ClerkProvider>
  );
}
